module.exports = __webpack_public_path__ + "static/media/Soprende a tus pequeños.c3d90ad4.webp";